module.exports = __webpack_public_path__ + "static/img/Laurence.06336a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Laurence.png
// module id = Jyau
// module chunks = 34